module.exports = __webpack_public_path__ + "assets/img/ofa-bg.5d1dcd03.png";